import React, { useState, useContext, useEffect } from "react";
import { InputErrorMessage } from "../../components/errorMessages";
import SimpleButton from "../../components/common/buttons/SimpleButton/SimpleButton";
import { useFormik } from "formik";
import { deleteAcctPassword } from "../../components/Validation";
import { IoEyeOff } from "react-icons/io5";
import { IoEye } from "react-icons/io5";
import MandatoryLabel from "../../components/common/label";
import { DeleteAccountAPI, NewregisteratoinApi } from "../../apis";
import { AppContext } from "../../appContext";
import { EditProfileLoader } from "../../components/loader/loader";
import ConfirmPopup from "../../components/confirmPopup/ConfirmPopup";
import toast from "react-hot-toast";
import MobileProfileTopNavigation from "./MobileProfileTopNavigation";
import DeleteAccountSection from "../../PageComponent/ProfilePage/DeleteAccountSection";
function MobileDeleteAccount() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  
  return (
    <div className="text-coalBlack pt-10">
      <MobileProfileTopNavigation pageTitle={"Delete account"} />
      <DeleteAccountSection />
    </div>
  );
}

export default MobileDeleteAccount;
